import React from 'react'
import styled from 'styled-components';
import colors from '../../../../lib/Colors';
import fonts from '../../../../lib/Fonts';
import * as PropTypes from 'prop-types'

const ErrorMessageWrapper = styled.div`
  margin: 0 0.2em;
  width: 100%;
  height: auto;
  text-align: center;
 
`
const ErrorMessageText = styled.p`
  margin-top:0;
  font-size: 0.8em;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  font-family: ${fonts.family.workSans};
  color: ${colors.red}
`

const ServerErrorMessage = ({text}) => {
  return (
    <ErrorMessageWrapper>
      <ErrorMessageText>{text}</ErrorMessageText>
    </ErrorMessageWrapper>
  )
}

ServerErrorMessage.propTypes = {
  text: PropTypes.string
}

export default ServerErrorMessage;
